var _excluded = ["children", "value", "checked", "onChange", "classes", "id", "is_wedding_dresses", "isRadioButton", "name"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import classesPropType from "@xo-union/classes-prop-type";
import uniqueID from "@xo-union/react-unique-id";
import Styles from "./styles.css";
var SilhouetteSwitch = function SilhouetteSwitch(_ref) {
  var children = _ref.children,
    value = _ref.value,
    checked = _ref.checked,
    onChange = _ref.onChange,
    classes = _ref.classes,
    id = _ref.id,
    is_wedding_dresses = _ref.is_wedding_dresses,
    isRadioButton = _ref.isRadioButton,
    name = _ref.name,
    rest = _objectWithoutProperties(_ref, _excluded);
  var switchClass = classes.container;
  switchClass += " ".concat(Styles['container'], " silhouettes-filter-option-").concat(value);
  switchClass += " ".concat(is_wedding_dresses ? Styles['wedding-dresses-silhouettes'] : '');
  if (checked) {
    switchClass += " ".concat(classes['is-selected']);
  }
  var switchType = isRadioButton ? 'radio' : 'checkbox';
  return /*#__PURE__*/React.createElement("div", {
    className: switchClass
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: classes.input,
    type: switchType,
    value: value,
    id: id,
    checked: checked,
    onChange: onChange,
    name: name || 'silhouettes'
  }, rest)), /*#__PURE__*/React.createElement("label", {
    className: "".concat(classes.label, " ").concat(Styles['label']),
    htmlFor: id
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true,
    className: "icon-grid ".concat(Styles['filter-icon-grid'], " ").concat(value === 'none-' + switchType ? 'silhouette-all' : '')
  }), /*#__PURE__*/React.createElement("div", {
    className: Styles['icon-value']
  }, value === 'none-' + switchType ? 'All' : children)));
};
process.env.NODE_ENV !== "production" ? SilhouetteSwitch.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  isRadioButton: PropTypes.bool,
  classes: classesPropType(['container', 'is-selected', 'input', 'label', 'icon'])
} : void 0;
export default uniqueID(['id'])( /*#__PURE__*/React.memo(SilhouetteSwitch));